<app-form-field-wrapper
  [label]="label"
  [name]="name"
  [colSize]="colSize"
  [formField]="formField">
  <p-multiSelect
    *ngIf="
      mode === 'commune' ? tagStore.asArray() : tagStore.allAsArray() as tags
    "
    (ngModelChange)="onChange($event)"
    [options]="tags"
    [(ngModel)]="selection"
    optionLabel="title"
    optionValue="_id"
    dataKey="_id">
    <ng-template pTemplate="header">
      @if (enableNewOption) {
        <p-button
          class="-ml-2 mr-3"
          size="small"
          [outlined]="true"
          [rounded]="true"
          (onClick)="openTagForm()"
          icon="fas fa-plus"></p-button>
      }
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-tag"></i>
        <div>{{ item.title }}</div>
      </div>
    </ng-template>
  </p-multiSelect>
</app-form-field-wrapper>
